import { getHeaders } from "./api"
import { handleGraphQlResp } from "../util/api_utils"
import axios from "axios"
import { backendHost } from "../util/environment_utils"

export const sendGraphqlRequest = query => {
    return axios({
        method: "post",
        url: `${backendHost}/v1/graphql`,
        data: {
            query,
        },
        headers: getHeaders(),
    })
        .then(resp => handleGraphQlResp(resp))
        .catch(error => error)
}



// WEBPACK FOOTER //
// ./src/api/graphQlClient.js